<template>
    <div class="report_detail" v-if="detail">
        <p>{{detail.txt1}}</p>
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.originalResult"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="sumFlowMass">
                    <template slot="header">
                        <div>总质量流量<br>(t/h)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumheat">
                    <template slot="header">
                        <div>总热能<br>（GJ）</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumheatLoss">
                    <template slot="header">
                        <div>总热损<br>（GJ）</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="sumheatLossRateTheory">
                    <template slot="header">
                        <div>总理论热损率<br>(%)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="sumheatLossRate">
                    <template slot="header">
                        <div>总实际热损率<br>（%）</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averVelocity">
                    <template slot="header">
                        <div>平均流速<br>(m/s)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="aveHeatLossPerSquare2">
                    <template slot="header">
                        <div>保温层外表面单位面积<br>平均散热损失(w/m^2)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt2}}</p>
        <center>{{detail.title}}</center>
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.result"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="pipeDiameter">
                    <template slot="header">
                        <div>管径<br>(mm)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="GSaving">
                    <template slot="header">
                        <div>热能节省量<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="HeatlossSavingRate">
                    <template slot="header">
                        <div>节能率<br>（%）</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="sumHeatLossRateTheory">
                    <template slot="header">
                        <div>损耗率<br>（%）</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="averVelocity">
                    <template slot="header">
                        <div>平均流速<br>(m/s)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="averHeatLossPerSquare">
                    <template slot="header">
                        <div>保温层外表面单位面积<br>平均散热损失(w/m^2)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div> 
        <p>{{detail.txt3}}</p>
    </div>
</template>
<script>
// 管径分析报告
export default {
    name:"DiameterDetail",
    props:["detail"]
}
</script>
<style lang="scss">
.report_detail{
    .repot-table{
        td,th{
            text-align: center;
        }
    }
}
</style>